import React from "react";
import PageTitle from "../../components/PageTitle";
import Loader from "../../components/Loader";
import ErrorResponse from "../../components/ErrorResponse";
import { useQuery } from "@tanstack/react-query";
import { axiosget } from "../../helpers/httprequest";

const Photo = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: ["dashboardDataset"],
    queryFn: async () => {
      const req = await axiosget("ms_dashboard");
      return req?.data;
    },
  });
  return (
    <div>
      <PageTitle title={`UPLOAD PASSPORT PHOTO`} sub={`This module allows you to upload your passport photograph`} />
      {isLoading && <Loader />}
      {error && <ErrorResponse type={`danger`} message={`Local server error: ${error}`} />}
      {data?.type !== undefined && <ErrorResponse type={`danger`} message={`${data?.message}`} />}
      <div className="row">
        <div className="col-md-6">
          <p>UPLOADED</p>
        </div>
        <div className="col-md-6">
          <p>UPLOAD</p>
        </div>
      </div>
    </div>
  );
};

export default Photo;
